import { LoadMode } from "./index195.js";
import { ThreadOptions } from "./index246.js";
function getNextThread(thread, loadMode) {
  const loadOptions = loadMode === LoadMode.single ? ThreadOptions.singleLoadOptions : ThreadOptions.doubleLoadOptions;
  const nextThreads = loadOptions.map((prop) => ({
    thread: thread.add(prop),
    start: prop.start
  })).filter((t) => t.thread);
  nextThreads.sort((a, b) => b.thread.data.size - a.thread.data.size);
  const nextThread = nextThreads.at(0);
  return nextThread;
}
export {
  getNextThread
};
//# sourceMappingURL=index237.js.map
